import { observer } from "mobx-react-lite";

import { CenteredBox, NoDataTile, useFormContext } from "@bps/fluent-ui";

import { BhbProvidersOnlineFilter } from "./BhbProvidersCard.types.ts";
import { BhbAvailability } from "./BhbProvidersFilter.tsx";

interface BhbProvidersNoResultsProps {
  singleProvider: boolean | undefined;
  providerCount: number;
}

export const BhbProvidersNoResults = observer(
  ({ singleProvider, providerCount }: BhbProvidersNoResultsProps) => {
    const {
      state: {
        values: { onlineAvailability }
      },
      actions: { reset }
    } = useFormContext<BhbProvidersOnlineFilter>();

    let text = "No records found";
    if (
      providerCount > 0 &&
      (!onlineAvailability ||
        !onlineAvailability.includes(BhbAvailability.DontShow))
    ) {
      if (singleProvider) {
        text = "Provider set as not showing for online bookings";
      } else {
        text = "No providers set as showing for online bookings";
      }
    }

    const linkText = singleProvider
      ? "Remove filters to view all locations"
      : "Remove filters to view all providers";

    return (
      <CenteredBox>
        <NoDataTile
          textProps={{ text }}
          linkProps={{
            text: linkText,
            onClick: () => {
              reset({
                onlineAvailability: [
                  BhbAvailability.ShowAndBook,
                  BhbAvailability.ShowAndCall,
                  BhbAvailability.DontShow
                ]
              });
            },
            hidden: providerCount === 0
          }}
          showBoxShadow={false}
        />
      </CenteredBox>
    );
  }
);
